import dayjs from "dayjs";
import advancedFormat from "dayjs/plugin/advancedFormat";
import relativeTime from "dayjs/plugin/relativeTime";

dayjs.extend(advancedFormat);
dayjs.extend(relativeTime);

function FormatTime({ time }: any) {
  const dbTimestamp = time;

  // Chuyển đổi dữ liệu từ cơ sở dữ liệu thành đối tượng dayjs
  const timestamp = dayjs(dbTimestamp);

  // Lấy khoảng thời gian so với hiện tại và định dạng nó giống Facebook
  const timeAgo = timestamp.fromNow();

  // Định dạng thời gian theo kiểu bài đăng trên Facebook
  const formattedTime = `${timeAgo} `;
  return <>{formattedTime}</>;
}

export default FormatTime;
